<div class="location-palette-container">
  <button class="btn btn-light close-btn" (click)="onCloseClick()">
    <i class="fa fa-times"></i>
  </button>

  <div class="marker-options">
    @for (color of markerColors; track color) {
      <div
        class="marker-icon"
        [class.selected]="selectedColor === color"
        [ngStyle]="{ color: color }"
        (click)="selectMarker(color)"
        [attr.title]="color + ' marker'"
        >
        <i class="fa-solid fa-location-dot fa-2x"></i>
      </div>
    }
  </div>


  <p class="instruction-text">Click on a marker then add it to the map by clicking anywhere on the globe.</p>
</div>
